import React,{useEffect} from 'react'
import Navbar from '../common/Navbar'
import Servicebanner from '../components/Ourservices/Servicebanner'
import Forwarding from '../components/Ourservices/Forwarding'
import Footer from '../common/Footer'
import { useLocation } from 'react-router-dom'



const Serviceforwarding = () => {
  const location = useLocation();
     useEffect(() => { const { search } = location; const containerId = search.substring(4);
      const element = document.getElementById(containerId); 
    //   if (element) { element.scrollIntoView({ behavior: "smooth", inline: "center", block: "start", });
    //  } }, [location]);
      if (element) {
        const headerHeight = document.querySelector("nav")?.offsetHeight || 80; 
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        
        window.scrollTo({
          top: elementPosition - headerHeight, 
          behavior: "smooth",
          inline: "center", block: "start",
        });
      }
    }, [location]);
  return (
    <div>
      <Navbar/>
    <Servicebanner/>
    <Footer/>
    </div>
  )
}

export default Serviceforwarding
